var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('reseller-product-form',{attrs:{"loading":_vm.loading,"resellerProductData":_vm.resellerProduct,"formErrors":_vm.formErrors},on:{"resellerProductSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }